import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Observable, combineLatest } from 'rxjs';
import { RetroalimentacionService } from '../_services/retroalimentacion.service';
import { MatDialog } from '@angular/material/dialog';
import { ComentariosService } from 'src/app/_components/glm-comentarios/comentarios.service';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';
import { RetroalimentacionDialogoComentarioComponent } from '../retroalimentacion-dialogo-comentario/retroalimentacion-dialogo-comentario.component';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { map, shareReplay, startWith, } from 'rxjs/operators';
import { AlumnoRetroalimentacion } from '../models/alumno-retroalimentacion';

@Component({
  selector: 'app-retroalimentacion-grid-tabla',
  standalone: false,
  templateUrl: './retroalimentacion-grid-tabla.component.html',
  styleUrls: ['../retroalimentacion.component.scss', './retroalimentacion-grid-tabla.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RetroalimentacionGridTablaComponent implements OnInit {

  @Input()
  alumnos$: Observable<any[]>;
  @Input()
  eventoUnidadId: number;
  @Input()
  evento$: Observable<any>;
  @Input()
  columnas: any[];
  @Input()
  fechasEvento$: Observable<any>;
  @Input()
  fechaActual$: Observable<string>;
  @Input()
  criterios: any[];
  @Input()
  alumnoForm: UntypedFormControl;
  @Input()
  fechaForm: UntypedFormControl;
  @Input()
  materiaForm: UntypedFormControl;
  @Input()
  materias$: Observable<any[]>;
  @Input()
  mostrarAutoevaluacionForm: UntypedFormControl;
  @Input()
  mostrarAutoevaluacion$: Observable<boolean>;

  @Input()
  checkForm: UntypedFormGroup;

  @Output()
  classroomActionEvent: EventEmitter<any>;
  @Output()
  navegarEstudianteEvent: EventEmitter<any>;

  filterForm: UntypedFormGroup;

  // TODO: Pedir esta tabla al api.
  estado = [{
    key: 'Todos', value: '0'
  }, {
    key: 'Asignada', value: 'NEW'
  // }, {
  //   key: 'Creado', value: 'CREATED'
  // }, {
  //   key: 'Entregado', value: 'TURNED_IN'
  }, {
    key: 'Publicado', value: 'RETURNED'
  // }, {
  //   key: 'Tomado por el estudiante', value: 'RECLAIMED_BY_STUDENT'
  }];

  evaluado = [{
    key: 'Todos', value: 0
  },
  {
    key: 'Evaluación completa', value: 1
  },
  {
    key: 'Evaluación incompleta', value: 2
  }];

  alumnosFilter$: Observable<any>;

  constructor(
    private retroalimentacionService: RetroalimentacionService,
    private matDialogRef: MatDialog,
    private comentariosService: ComentariosService,
    private customAlertService: CustomAlertService,
  ) {
    this.classroomActionEvent = new EventEmitter();
    this.navegarEstudianteEvent = new EventEmitter();
  }

  ngOnInit(): void {
    this.filterForm = new UntypedFormGroup({
      estado: new UntypedFormControl('0'),
      evaluado: new UntypedFormControl(0)
    });

    const alumnosComentarioAtualizar$ = combineLatest([this.alumnos$, this.comentariosService.nuevoComentario$]).pipe(
      map(([alumnos, comentario]) => {
        if (comentario.targetId !== 0 && comentario.tipo === 'unidadeventoalumno') {
          alumnos.forEach(alumno => {
            if (alumno.eventoMateriaAlumnoId === comentario.targetId) {
              alumno.comentarios++;
            }
          });
        }
        return alumnos;
      })
    );

    this.alumnosFilter$ = combineLatest([alumnosComentarioAtualizar$,
      this.filterForm.valueChanges.pipe(startWith(this.filterForm.value)), this.comentariosService.nuevoComentario$]).pipe(
      map(([alumnos, filter]) => {
        return alumnos.filter(item => {
          const completa = item.criterios.length >= this.columnas.length - 1;
          const estado = (filter.estado === '0' || ((item.submission ? item.submission.state === filter.estado : true) && (
          (item.devuelto === true ? filter.estado === 'RETURNED' : true) && (item.devuelto === false ? filter.estado === 'NEW' : true))));
          return estado && ((filter.evaluado === 0) || (filter.evaluado === 1 && completa) || (filter.evaluado === 2 && !completa));
        });
      }),
      shareReplay(1)
    );
  }

  abrirModalComentario(alumno: AlumnoRetroalimentacion) {
    if (alumno.eventoMateriaAlumnoId  === 0) {
      this.retroalimentacionService.createEvaluation(alumno.unidadEventoMateriaId, alumno.id).subscribe(res => {
        alumno.eventoMateriaAlumnoId = res;
        this.matRefOpen(alumno);
      },
      err => {
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible crear la instancia de evaluación para el cometario. <br> Código de error: ${err.statusText}`
        });
      });
    } else {
      this.matRefOpen(alumno);
    }
  }

  matRefOpen(alumno: any) {
    combineLatest(([
      this.comentariosService.getComentariosPorObjeto(alumno.eventoMateriaAlumnoId, 'unidadeventoalumno'),
      this.comentariosService.getComentariosPorObjeto(alumno.eventoMateriaAlumnoId, 'UnidadEventoAlumnoAutoevaluacion')
    ])).pipe(
      map(([evento, autoevaluacion]) => {
        return [...evento, ...autoevaluacion];
      })
    )
    .subscribe(
      res => {
        this.matDialogRef.open(RetroalimentacionDialogoComentarioComponent , {
          width: '65%',
          height: '75%',
          // maxWidth: '100vw !important',
          // maxHeight: 'calc(-64px + 100vh)',
          // position: { bottom: '0'},
          // disableClose: true,
          data: {
            alumno,
            evento$: this.evento$,
            comentarios: res || [],
            targetId: alumno.eventoMateriaAlumnoId,
            fechas$: this.fechasEvento$
          }
        });
      },
      err => {
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible obtener los comentarios. <br> Código de error: ${err.statusText}`
        });
      }
    );
  }

  selectAll(value: boolean, alumnos: any[]) {
    alumnos.forEach(alumno => {
      this.checkForm.get('' + alumno.id).setValue(value);
    });
  }

  listaAlumnos(): any[] {
    const resp = [];
    const value = this.checkForm.value;
    for (const property in value) {
      if (value.hasOwnProperty(property)) {
        if (value[property]) {
          resp.push(+property);
        }
      }
    }
    return resp;
  }

  classroomAction(alumno: any | string, accion: string) {
    const alumnos = alumno === 'seleccionados' ? this.listaAlumnos() : alumno;
    this.classroomActionEvent.emit({alumnos, accion});
  }

  navegarEstudiante(alumno) {
    this.navegarEstudianteEvent.emit(alumno);
  }

  handleAccion(evento, alumno) {
    if (evento.accion.tipo === 'navegar') {
      this.navegarEstudianteEvent.emit(evento.persona);
    } else if (evento.accion.tipo === 'publicar' || evento.accion.tipo === 'despublicar' || evento.accion.tipo === 'comentar') {
      this.classroomActionEvent.emit({alumnos: [alumno.id], accion: evento.accion.tipo});
    }
  }

}
